import React, { useEffect } from "react";
import styled from "styled-components";
import { ReactComponent as Xclose } from "../../../assets/icons/x-close1.svg";
import download from "../../../assets/icons/download-020.svg";
import {
    privacyEffectiveDate,
    privacyLastUpdated,
    privacyPolicyData,
    privacyPolicyDownloadLink,
    privacyPolicyIntroData,
    privacyTitle,
    privacyVersion,
    termsAndConditionsData,
    termsAndConditionsDownloadLink,
    termsAndConditionsEffectiveDate,
    termsAndConditionsIntroData,
    termsAndConditionsLastUpdated,
    termsAndConditionsTitle,
    termsAndConditionsVersion
} from "../../../config/termsAndPrivacy";

// #region SCOPED CSS
const StyledPage = styled.div`
    &.terms-conditions-container {
        width: 400px;
        background-color: #121821;
        position: absolute;
        right: 0px;
        height: 100dvh;
        z-index: 99999999;
        padding-top: 24px;
        padding-bottom: 24px;
        box-sizing: border-box;
    }

    @media (max-width: 1024px) {
        &.terms-conditions-container {
            width: 100%;
        }
    }

    .frame-313297,
    .frame-313297 * {
        box-sizing: border-box;
    }
    .frame-313297 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        display: flex;
        padding: 0 24px;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        height: 100%;
        position: sticky;
        overflow-y: scroll;
        overflow-x: hidden;
    }
    .frame-313303 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313299 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313300 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .btn-icon-swap {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 120px;
        height: 35px;
        position: relative;
    }
    .frame-289 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .download-02 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    ._3-imported {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--button-text-small-font-size, 10px);
        letter-spacing: var(--button-text-small-letter-spacing, 0.0125em);
        font-weight: var(--button-text-small-font-weight, 400);
        text-transform: uppercase;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        top: 1px;
    }
    .frame-313301 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        width: 35px;
        position: relative;
        margin-bottom: 16px;
    }
    .x-close {
        flex-shrink: 0;
        width: 22px;
        height: 22px;
        position: relative;
        overflow: visible;
        color: var(--text-and-icons-gray-100, #d1d1d1) !important;
    }
    .frame-313302 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313298 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .b-otag-norge-as-privacy-policy {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--heading-3-font-size, 20px);
        font-weight: 600;
        position: relative;
        flex: 1;
    }
    .last-updated-01-08-2022 {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
`;

const TermsAndPrivacyStyled = styled.div`
    & {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-top: 16px;
    }
    .terms-header {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--body-font-size, 16px);
        font-weight: 600;
        position: relative;
        align-self: stretch;
    }
    .terms-text {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        align-self: stretch;
        overflow-wrap: anywhere;
    }
    .terms-text-ul {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        list-style-type: disc;
        padding-left: 1em;
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        margin: 0;
    }
    .terms-text-ol {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        list-style-type: decimal;
        padding-left: 1em;
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        margin: 0;
    }
    .terms-text-ul li,
    .terms-text-ol li {
        margin-bottom: 8px;
        margin-left: 12px;
    }
    .terms-text-ul li:last-child,
    .terms-text-ol li:last-child {
        margin-bottom: 0;
    }

    .terms-block-content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        min-width: 0;
    }

    .terms-text-paragraph {
        margin: 0;
    }

    .terms-text-lines {
        display: flex;
        flex-direction: column;
    }

    .terms-block {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }

    .terms-card-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        min-width: 0;
    }

    .terms-card {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border: 1px solid var(--backgrounds-and-lines-n-300, #283240);
        border-radius: 6px;
        padding: 12px 14px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        width: 100%;
        box-sizing: border-box;
    }

    .terms-card-title {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: var(--subtitle-1-font-size, 14px);
        font-weight: 600;
        line-height: 19px;
    }

    .terms-card-body {
        display: flex;
        flex-direction: column;
        gap: 6px;
        font-size: 13px;
        line-height: 18px;
        color: var(--text-and-icons-gray-200, #8f9ca3);
    }

    .terms-card-row {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .terms-card-label {
        color: var(--text-and-icons-gray-200, #7c868b);
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        font-weight: 600;
    }

    .terms-card-value {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: 13px;
        line-height: 18px;
    }
`;
// #endregion

/**
 * Shows the Terms and Conditions panel
 * @param {string} titleOverride - titleOverride of the panel
 * @param {string} type - Type of the panel (terms or privacy)
 * @param {function} onCloseClicked - Function to call when the close button is clicked
 * @returns {JSX.Element}
 */
const TermsAndPrivacyPanel = ({ titleOverride, type = "terms", onCloseClicked }) => {
    // #region VARS
    const version = type === "terms" ? termsAndConditionsVersion : privacyVersion;
    const effectiveDate = type === "terms" ? termsAndConditionsEffectiveDate : privacyEffectiveDate;
    const lastUpdated = type === "terms" ? termsAndConditionsLastUpdated : privacyLastUpdated;
    const title = titleOverride || (type === "terms" ? termsAndConditionsTitle : privacyTitle);
    const downloadButtonURL = type === "terms" ? termsAndConditionsDownloadLink : privacyPolicyDownloadLink;
    // #endregion

    // #region METHODS
    const handleDownload = () => {
        window.open(downloadButtonURL, "_blank");
    };

    const handleClose = () => {
        if (onCloseClicked) onCloseClicked();
    };
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        const handleClickOutside = event => {
            if (event.target.closest(".terms-conditions-container") === null) {
                handleClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // #endregion

    // #region RENDER
    return (
        <StyledPage className="terms-conditions-container">
            <div className="frame-313299 mb-16px ml-24px mr-24px">
                <div className="frame-313300">
                    {downloadButtonURL && (
                        <div className="btn-icon-swap cursor-pointer" onClick={handleDownload}>
                            <div className="frame-289">
                                <img className="download-02" src={download} alt="" />
                                <div className="_3-imported">DOWNLOAD</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="frame-313301">
                    <Xclose className="x-close cursor-pointer" onClick={handleClose} alt="" />
                </div>
            </div>

            <div className="frame-313297">
                <div style={{ marginBottom: "54px" }}>
                    <div className="frame-313303">
                        <div className="frame-313302">
                            <div className="frame-313298">
                                <div className="b-otag-norge-as-privacy-policy">{title}</div>
                            </div>
                            <div className="terms-meta-info" style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                {version && <div className="last-updated-01-08-2022">Version: {version}</div>}
                                {effectiveDate && (
                                    <div className="last-updated-01-08-2022">Effective date: {effectiveDate}</div>
                                )}
                                {lastUpdated && (
                                    <div className="last-updated-01-08-2022">Last updated: {lastUpdated}</div>
                                )}
                            </div>
                        </div>
                    </div>

                    {type === "terms"
                        ? GenerateContentHTML(termsAndConditionsIntroData, termsAndConditionsData)
                        : GenerateContentHTML(privacyPolicyIntroData, privacyPolicyData)}
                </div>
            </div>
        </StyledPage>
    );
    // #endregion
};
export default TermsAndPrivacyPanel;

// #region CONTENT RENDERERS
const GenerateContentHTML = (titleLines, termsBlocks) => {
    return (
        <TermsAndPrivacyStyled>
            {titleLines.map((item, index) => (
                <div key={index} className="terms-text">
                    {GenerateInlineText(item)}
                </div>
            ))}

            {termsBlocks.map((item, index) => (
                <div key={index} className="terms-block">
                    <div className="terms-header">{item.title}</div>
                    <div className="terms-text terms-block-content">
                        {item.blocks.map((block, blockIndex) => GenerateLegalBlock(block, blockIndex))}
                    </div>
                </div>
            ))}
        </TermsAndPrivacyStyled>
    );
};

const GenerateInlineText = text => {
    return String(text)
        .split(/(\*\*.*?\*\*)/g)
        .filter(Boolean)
        .map((part, index) =>
            part.startsWith("**") && part.endsWith("**") ? <b key={index}>{part.slice(2, -2)}</b> : part
        );
};

const GenerateLegalBlock = (block, key) => {
    if (block.t === "p") {
        return (
            <p key={key} className="terms-text-paragraph">
                {GenerateInlineText(block.text)}
            </p>
        );
    }

    if (block.t === "lines") {
        return (
            <div key={key} className="terms-text-lines">
                {block.lines.map((line, lineIndex) => (
                    <span key={lineIndex}>{GenerateInlineText(line)}</span>
                ))}
            </div>
        );
    }

    if (block.t === "ul" || block.t === "ol") {
        const ListTag = block.t;

        return (
            <ListTag key={key} className={`terms-text-${block.t}`}>
                {block.items.map((item, itemIndex) => (
                    <li key={itemIndex}>{GenerateInlineText(item)}</li>
                ))}
            </ListTag>
        );
    }

    if (block.t === "cards") {
        return (
            <div key={key} className="terms-card-list">
                {block.cards.map((card, cardIndex) => (
                    <div key={cardIndex} className="terms-card">
                        {card.title && <div className="terms-card-title">{GenerateInlineText(card.title)}</div>}
                        {card.text && <div className="terms-card-body">{GenerateInlineText(card.text)}</div>}
                        {card.rows && (
                            <div className="terms-card-body">
                                {card.rows.map((row, rowIndex) => (
                                    <div key={rowIndex} className="terms-card-row">
                                        {row.label && (
                                            <span className="terms-card-label">{GenerateInlineText(row.label)}</span>
                                        )}
                                        <span className="terms-card-value">{GenerateInlineText(row.value)}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    }

    return null;
};
// #endregion
